import { rhybusRListsHttp } from '../api/rhybus-list-http'
import { ListNames } from '../config/configuration'
import { getContentAuditFields } from './contentManagement'
import {
    TT_RN_VERSION_NAME, TT_RN_RELEASE_DATE,
    TT_RN_NEW_FEATURES, TT_RN_RESOLVED_ISSUES, TT_RN_KNOWN_ISSUES,
    TT_COMMON_IS_ARCHIVED
} from './tooltip-ids'

// ─── Tooltip ID map ───────────────────────────────────────────────────────────
/** Maps each Release Notes form field key to its ToolTipID. */
export const releaseNotesTooltipIds: Record<string, string> = {
    VersionName:    TT_RN_VERSION_NAME,
    ReleaseDate:    TT_RN_RELEASE_DATE,
    NewFeatures:    TT_RN_NEW_FEATURES,
    ResolvedIssues: TT_RN_RESOLVED_ISSUES,
    KnownIssues:    TT_RN_KNOWN_ISSUES,
    IsArchived:     TT_COMMON_IS_ARCHIVED
}

export type ReleaseNoteItem = {
    ID: number
    VersionName: string
    ReleaseDate: string
    NewFeatures: string
    ResolvedIssues: string
    KnownIssues: string
    Modified?: string
    IsArchived: boolean
}

const normalizeIsArchived = (value: any): boolean =>
  value === 'Yes' || value === true
export const getReleaseNotesItems = async (): Promise<ReleaseNoteItem[]> => {
  const list = await rhybusRListsHttp().getList(ListNames.RELEASE_NOTES)
  const items = [...(await list.query().orderBy([{ orderBy: 'ItemModified', ascending: false }]).get<any>())]
  return items.map((item: any) => ({
    ...item,
    ID: item.ID ?? item.Id ?? item._Id ?? item.eKey,
    Id: item.Id ?? item.ID ?? item._Id ?? item.eKey,
    VersionName: item.VersionName ?? item.Title ?? '',
    ItemModifiedBy: typeof item.ItemModifiedBy === 'string'
      ? { Title: item.ItemModifiedBy }
      : item.ItemModifiedBy ?? { Title: 'System' },
  }))
}

const stripReleaseNoteNonListFields = (data: any) => {
  const {
    ID: _id, Id: _Id, Title: _title, Modified: _mod,
    ItemModifiedBy: _imb, ItemCreatedBy: _icb,
    AttachmentFiles: _af, IsDeleted: _del,
    createdBy: _cb, createdOn: _co, modifiedBy: _mb, modifiedOn: _mo,
    eKey: _ek, eTag: _et,
    ...rest
  } = data
  return rest
}

export const saveReleaseNoteItem = async (data: Partial<ReleaseNoteItem>): Promise<void> => {
  const auditFields = await getContentAuditFields()
  await (await rhybusRListsHttp().getList(ListNames.RELEASE_NOTES)).addOrUpdateItem({
    ...stripReleaseNoteNonListFields(data),
    IsArchived: normalizeIsArchived(data.IsArchived),
    ...auditFields,
  } as any)
}

export const editReleaseNoteItem = async (data: Partial<ReleaseNoteItem>): Promise<void> => {
  const { eKey, eTag } = data as any
  const auditFields = await getContentAuditFields((data as any).ItemCreated)
  await (await rhybusRListsHttp().getList(ListNames.RELEASE_NOTES)).addOrUpdateItem({
    ...stripReleaseNoteNonListFields(data),
    IsArchived: normalizeIsArchived(data?.IsArchived),
    ...auditFields,
    eKey,
    eTag,
  } as any)
}
export const removeReleaseNoteItem = async (data: Partial<ReleaseNoteItem>): Promise<void> =>
  await (await rhybusRListsHttp().getList(ListNames.RELEASE_NOTES)).deleteItem((data as any).eKey, (data as any).eTag)
